export const DEFAULT_CONSTANTS = {
  ACCUMULATE_TYPE: {},
  ORDER_CANCEL_REASON: {},
  ORDER_STATE: {},
  ORDER_TYPE: {},
  PAYMENT_METHODS: {},
  POINT_ACTION: {},
  STORE_DELIVERY_FEE_CONDITION: {},
  STORE_ETC_CONDITION: {},
  STORE_ORDER_BY_CONDITION: {},
  STORE_REQUIRED_PAY_AMOUNT_CONDITION: {},
  STORE_STAR_CONDITION: {},
  STORE_STATUS: {},
  TIME_SPEND: {}
};

export const mergeConstants = (constants = {}) => ({
  ...DEFAULT_CONSTANTS,
  ...(constants ?? {})
});

export const hasLoadedConstants = (constants = {}) => {
  const safeConstants = constants ?? {};
  return Object.keys(safeConstants).some((key) => Object.keys(safeConstants[key] ?? {}).length > 0);
};
